type Listener<T> = (data: T) => void;

class EventBus<E extends string, D extends Record<E, unknown>> {
  private listeners: { [event in E]?: Listener<D[E]>[] } = {};

  on<T extends E>(event: T, listener: Listener<D[T]>): () => void {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event]!.push(listener as Listener<D[E]>);

    // Return an unsubscribe function
    return () => this.off(event, listener);
  }

  off<T extends E>(event: T, listener: Listener<D[T]>): void {
    if (!this.listeners[event]) {
      return;
    }
    this.listeners[event] = this.listeners[event]!.filter(
      (l) => l !== listener,
    );
  }

  emit<T extends E>(event: T, data: D[T]): void {
    if (!this.listeners[event]) {
      return;
    }
    this.listeners[event]!.forEach((listener) => listener(data));
  }
}

// Define your event types and their corresponding data payloads
interface AppEvents {
  SHOW_TOAST: {
    message: string;
    type: 'success' | 'error' | 'warning' | 'info';
  };
}

// Create a singleton instance of the event bus
export const eventBus = new EventBus<keyof AppEvents, AppEvents>();
